import React from "react";
import styles from "./Sidebar1.module.css";
import logo from "../../assets/logo/oakawe.png";
import SidebarMenu1 from "./SidebarMenu1";
import { SidebarData1 } from "./SidebarData1";

const Sidebar1 = () => {
  return (
    <>
      <div className={styles.sidebar_wrap}>
        {SidebarData1?.map((item, index) => (
          <SidebarMenu1 item={item} key={index} />
        ))}
      </div>
    </>
  );
};

export default Sidebar1;
